import React from 'react';
import NotFound from '~/components/not-found';
import Header from '~/components/header';
import Footer from '~/components/footer';
import Loading from '~/components/loading/loading';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getMessage } from '../../assets/utils';
import FileViewer from 'react-file-viewer';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message_load: 'loading',
            loaded: false
        }
    }
    
    render() {
        require('./scss/about.scss');
        return(
            <>
                <div className='container-page container-fluid show pt-5' style={{marginTop: '-15px'}}>
                    <main id="panel">
                        <h1 className='text-center ml-auto mr-auto'>{getMessage('who_ami')}</h1>
                        <FileViewer
                            fileType={'docx'}
                            filePath={process.env.PUBLIC_URL + '/terms/about-us.docx'}/>
                    </main>
                </div>
                <Footer />
            </>
        );
    }
}

export default withRouter(About);